import {Component, OnInit} from '@angular/core';
import {Article} from "../../../model/article";
import {SliderHorizontalComponent} from "../../elements/slider-horizontal/slider-horizontal.component";
import {ApiService} from "../../../services/api.service";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-heroes',
    imports: [
        SliderHorizontalComponent,
        NgIf
    ],
    templateUrl: './heroes.component.html',
    styleUrl: './heroes.component.scss'
})
export class HeroesComponent implements OnInit {

    constructor(
        private apiService: ApiService
    ) { }

    articles: Article[] = [];

    loading: boolean = true;

    ngOnInit() {
        this.loading = true;
        this.apiService.getPaginatedData('public/hero', 1, 1000, '').subscribe((data) => {
            this.articles = data.content.sort((a: any, b: any) => a.orderNumber - b.orderNumber).map((v: any, index: number) => new Article({
                id: index,
                coordinates: [],
                title: v.title,
                subTitle: v.subTitle,
                type: v.image ? 'hero' : 'hero-main',
                text: v.text,
                image: v.image,
                orderNumber: v.orderNumber
            }));
            setTimeout(() => {
                this.loading = false;
            }, 0);
        })
    }

    // articles: Article[] = [
    //     {
    //         id: 0,
    //         coordinates: [],
    //         title: 'ГЕРОИ',
    //         subTitle: '',
    //         type: 'hero-main',
    //         text: 'Имена советских железнодорожников, которые самоотверженно работали, внедряя передовые методы труда, были известны всей стране: машинистов Петра Кривоноса, Николая Лунина, Ивана Блинова, непревзойденного мастера ремонта  паровозов Ивана Сафронова, механика углеподъемного крана Анания Черепанова. Были в их числе и легендарные паровозники-северяне Александр Папавин и Василий Болонин.\n' +
    //             'Рационализаторские предложения по бесперебойной работе особенно пригодились в суровые военные времена, когда потребовалось увеличить темп продвижения воинских грузов и железнодорожный транспорт перешел на круглосуточный график. \n' +
    //             'С последовательностью и упорством занялись изучением и применением опыта выдающихся передовиков-рационализаторов и на Северной магистрали. Железнодорожники внедряли в работу лунинско-папавинские методы труда, водили поезда-тяжеловесы; добивались экономии средств, затрачиваемых на содержание паровозов; обеспечивали удлинение пробега локомотивов и отличное содержание вверенной техники; инициировали продвижение поездов без дополнительного набора топлива на промежуточных станциях; выполняли и перевыполняли задания по формированию поездов и многое другое.\n' +
    //             'С галереей портретов железнодорожников-передовиков, героев только на первый взгляд мирного труда, можно познакомиться в этом разделе «Карты памятных мест». Здесь вы найдете как прославленные фамилии, так и совсем не известные, но все они приближали Победу, никто не будет забыт. \n',
    //         miniText: true
    //     },
    //     {
    //         id: 1,
    //         coordinates: [],
    //         img: '/app/assets/hero/papavin.png',
    //         title: 'папавин\n' +
    //             'александр\n' +
    //             'петрович',
    //         subTitle: '',
    //         type: 'hero',
    //         text: 'Герой Социалистического Труда, инженер-майор тяги, старший машинист паровоза СУ-99-0-7 Депо Ярославль. За сохранение ответственных деталей паровоза и продления сроков их действия, за обеспечение удлиненных пробегов локомотива в сравнении с нормами награжден двумя орденами Ленина, двумя значками «Почетному железнодорожнику», значками «Ударнику Сталинского Призыва», «Отличный паровозник», медалью «За доблестный труд в Великой Отечественной войне 1941-1945гг.»'
    //
    //     },
    //     {
    //         id: 2,
    //         coordinates: [],
    //         img: '/app/assets/hero/voronichev.png',
    //         title: 'Вороничев\n' +
    //             'Михаил\n' +
    //             'Парамонович',
    //         subTitle: 'Генерал-директор Движения III ранга. Депутат Верховного Совета РСФСР.',
    //         type: 'hero',
    //     },
    //     {
    //         id: 3,
    //         coordinates: [],
    //         img: '/app/assets/hero/sorokin.png',
    //         title: 'Сорокин Александр Петрович',
    //         subTitle: 'Инженер-майор тяги, инженер паровозного депо Ярославль.',
    //         type: 'hero',
    //         text: 'За 44 года работы на транспорте он внес в паровозное дело ряд ценных рационализаторских предложений, способствующих развитию папавинского движения. За разработку новых методов содержания и ремонта паровозов награжден орденом «Знак Почета», значком «Почетному железнодорожнику», значком «Отличный паровозник», медалью «За доблестный труд в Великой Отечественной войне 1941-1945гг.»'
    //     },
    //     {
    //         id: 4,
    //         coordinates: [],
    //         img: '/app/assets/hero/nyhalow.png',
    //         title: 'Нюхалов Валентин Тихонович\n',
    //         subTitle: 'Техник тяги I ранга, старший машинист паровоза СО-18-1991 депо Всполье. Член ВКПБ.',
    //         type: 'hero',
    //         text: 'За внедрение в новой работе лунинско-папавинских и других передовых методов труда, за Кривоносовское вождение товарных поездов с грузами для фронта награжден орденом Ленина. Не раз выходил победителем в единоборстве с фашистскими бомбардировщиками.'
    //     },
    //     {
    //         id: 5,
    //         coordinates: [],
    //         img: '/app/assets/hero/bylochkin.png',
    //         title: 'Булочкин Николай Иванович\n',
    //         subTitle: 'Инженер-лейтенант тяги, старший машинист паровоза СУ-98-93 депо Ярославль, член ВКПБ, бывший напарник товарища Папавина. ',
    //         type: 'hero',
    //         text: 'Ныне машинист I класса. За внедрение в работе лунинско-папавинских методов труда, за образцовое вождение пассажирских поездов награжден орденом Ленина, знаком «Почетному железнодорожнику», медалью «За доблестный труд в Великой Отечественной войне 1941-1945гг.»'
    //     },
    //     {
    //         id: 6,
    //         coordinates: [],
    //         img: '/app/assets/hero/petrow.png',
    //         title: 'Петров Михаил Иванович\n',
    //         subTitle: 'Техник-лейтенант тяги, машинист-инструктор паровозного депо Всполье. Член ВКПБ. ',
    //         type: 'hero',
    //         text: 'Работая первые годы войны старшим машинистом, является инициатором организации колонны паровозов имени 25 годовщины Красной Армии и продвижения поездов без дополнительного набора топлива на промежуточных станциях. Награжден значком «Ударнику сталинского призыва».'
    //     },
    //     {
    //         id: 7,
    //         coordinates: [],
    //         img: '/app/assets/hero/lakshin.png',
    //         title: 'Лакшин Никанор Никанорович\n',
    //         subTitle: 'Техник движения III ранга, составитель поездов станции Лосиноостровская. Член ВКПБ. ',
    //         type: 'hero',
    //         text: 'В период Великой Отечественной войны бригада товарища Лакшина ежемесячно на формировании Красновских поездов экономила около 4600 вагоно-часов.'
    //     },
    //     {
    //         id: 8,
    //         coordinates: [],
    //         img: '/app/assets/hero/ygarow.png',
    //         title: 'Угаров Иван Петрович',
    //         subTitle: 'Инженер-лейтенант движения, участковый диспетчер Московского Отделения движения. ',
    //         type: 'hero',
    //         text: 'Является инициатором в организации погрузки и выгрузки без отцепки вагонов от поездов, на чем он сэкономил не одну тысячу вагоно-часов.'
    //     },
    //     {
    //         id: 9,
    //         coordinates: [],
    //         img: '/app/assets/hero/mardasov.png',
    //         title: 'Мардасов Николай Иванович\n',
    //         subTitle: 'Техник движения III ранга, составитель поездов станции Сонково.',
    //         type: 'hero',
    //         text: 'Во время налетов вражеской авиации никогда не покидал своего поста. Спас от бомб много составов с ценным грузом для фронта. Несмотря на увеличение объемов работы в несколько десятков раз против пропускной способности станции, он, применяя передовые методы труда, выполнял и перевыполнял задания по формированию поездов.'
    //     },
    //     {
    //         id: 10,
    //         coordinates: [],
    //         img: '/app/assets/hero/galkin.png',
    //         title: 'Галкин Петр Матвеевич\n',
    //         subTitle: 'Составитель поездов станции Иваново-Сортировочная.',
    //         type: 'hero',
    //         text: 'Применяя передовые методы Краснова и Кожухоря, он систематически перевыполнял установленные нормой выработки. При затруднениях экипировки паровозов его бригада принимала непосредственное участие в снабжении паровоза топливом.'
    //     },
    //     {
    //         id: 11,
    //         coordinates: [],
    //         img: '/app/assets/hero/novicow.png',
    //         title: 'Новиков Алексей Васильевич\n',
    //         subTitle: 'Техник тяги II ранга, старший машинист углеподъемочного крана №724 Сонковского склада топлива.',
    //         type: 'hero',
    //         text: 'В период Великой Отечественной войны более года выходил победителем во Всесоюзном социалистическом соревновании и его крану присваивалось звание «Лучший углеподъемочный кран по сети железных дорог Советского союза».'
    //     },
    //     {
    //         id: 12,
    //         coordinates: [],
    //         img: '/app/assets/hero/golovin.png',
    //         title: 'Головин Никифор Дмитриевич\n',
    //         subTitle: 'Инженер-лейтенант движения, начальник Московского пассажирского отделения. ',
    //         type: 'hero',
    //         text: 'Инициатор организации на отделении комсомольско-молодежных бригад. Его бригады неоднократно завоевывали переходящее «Дорожное Красное Знамя» и звание «фронтовой бригады».'
    //     },
    //     {
    //         id: 13,
    //         coordinates: [],
    //         img: '/app/assets/hero/hlebnikow.png',
    //         title: 'Хлебников Александр Александрович\n',
    //         subTitle: 'Старший машинист паровозного депо Лосиноостровская.',
    //         type: 'hero',
    //         text: 'Он систематически добивается удлиненных пробегов паровоза между подъемочными и средними ремонтами.'
    //     },
    //     {
    //         id: 14,
    //         coordinates: [],
    //         img: '/app/assets/hero/ayamzov.png',
    //         title: 'Азямов Василий Иванович\n',
    //         subTitle: 'Дежурный по путям станции Приволжье.',
    //         type: 'hero',
    //         text: 'В дни Великой Отечественной войны, работая составителем поездов, он первый на дороге проявил инициативу заключения соцдоговоров на одно дежурство с работниками транспортных цехов промышленных предприятий.'
    //     },
    //     {
    //         id: 15,
    //         coordinates: [],
    //         img: '/app/assets/hero/simonow.png',
    //         title: 'Симонов Леонид Павлович\n',
    //         subTitle: 'Слесарь-гарнитурщик паровозного депо Ярославль.',
    //         type: 'hero',
    //         text: '1927 года рождения, член ВЛКСМ. Руководя комсомольско-молодежной бригадой, вывел ее в число передовых на дороге.'
    //     },
    //     {
    //         id: 16,
    //         coordinates: [],
    //         img: '/app/assets/hero/kartashow.png',
    //         title: 'Карташов Николай Иванович\n',
    //         subTitle: 'Старший бригадный тяги, токарь колесно-токарного цеха Московского вагонного участка.',
    //         type: 'hero',
    //         text: 'За высокую производительность труда и хорошее качество работы при обточке бандажей колесных пар для вагонов награжден знаком «Почетному железнодорожнику» и медалью «За оборону Москвы». Досрочно к 1 ноября 1946 года выполнил годовой план Новой Сталинской Пятилетки.'
    //     },
    //     {
    //         id: 17,
    //         coordinates: [],
    //         img: '/app/assets/hero/kravchenko.png',
    //         title: 'Кравченко Иван Мефодьевич\n',
    //         subTitle: 'Техник движения II ранга, главный кондуктор Московского резерва.',
    //         type: 'hero',
    //         text: 'По его инициативе были созданы едины комплексные бригады по обслуживанию зонных поездов, благодаря чему был высвобожден один паровоз.'
    //     },
    //     {
    //         id: 18,
    //         coordinates: [],
    //         img: '/app/assets/hero/shishkina.png',
    //         title: 'Шишкина Анна Самойловна\n',
    //         subTitle: 'Старший бригадный движения, старшая стрелочница станции Всполье. Член ВКПБ. ',
    //         type: 'hero',
    //         text: 'За период Великой Отечественной войны она предотвратила не одну аварию и могущие быть крушения. Приняла активное участие в подготовке стрелочников из молодых кадров, пришедших на работу во время войны.'
    //     },
    //     {
    //         id: 19,
    //         coordinates: [],
    //         img: '/app/assets/hero/kruglicow.png',
    //         title: 'Кругликов Сергей Фёдорович\n',
    //         subTitle: 'Техник движения II ранга, составитель поездов станции Всполье.',
    //         type: 'hero',
    //         text: 'За быструю и качественную разборку составов через механизированную горку с одновременным формирование поездов по методу Краснова награжден орденом Ленина и значком «Ударнику Сталинского призыва».'
    //     },
    //     {
    //         id: 20,
    //         coordinates: [],
    //         img: '/app/assets/hero/ivanov.png',
    //         title: 'Иванов Петр Иванович\n',
    //         subTitle: 'Старший бригадный тяги, главный кондуктор Московского резерва.',
    //         type: 'hero',
    //         text: 'Активно принимал участие в организации стопроцентного проследования поездов по расписанию путем заключения соцдоговоров на одну поездку.'
    //     },
    //     {
    //         id: 21,
    //         coordinates: [],
    //         img: '/app/assets/hero/gydkov.png',
    //         title: 'Гудков Иван Ермолович\n',
    //         subTitle: 'Техник движения III ранга, дежурный по сортировочной горке станции Лосиноостровская. Член ВКПБ.',
    //         type: 'hero',
    //         text: 'В период Великой Отечественной войны, работая руководителем комплексной составительской бригады, систематически перевыполнял задания по формированию поездов и разборке составов.'
    //     },
    //     {
    //         id: 22,
    //         coordinates: [],
    //         img: '/app/assets/hero/kozlow.png',
    //         title: 'Козлов Семён Иванович\n',
    //         subTitle: 'Старший машинист электровоза ВЛ-19-27 электровозного дело Москва III-я.\n',
    //         type: 'hero',
    //         text: 'Применяя в своей работе папавинско-лунинские методы работы он добился удлинения пробега электровоза между подъёмочными ремонтами в два раза больше нормы.'
    //     },
    //     {
    //         id: 23,
    //         coordinates: [],
    //         img: '/app/assets/hero/kaprovskiy.png',
    //         title: 'Карповский Степан Сергеевич\n',
    //         subTitle: 'Техник тяги III ранга, мастер котельного цеха паровозного депо Рыбинск.',
    //         type: 'hero',
    //         text: 'В период Великой Отечественной войны семнадцатилетним юношей пришел работать в депо из железнодорожного училища, а сейчас едва ли не самый молодой в стране мастер-котельщик. Его бригада ежемесячно вырабатывает 1,5-2 нормы, справляясь с любым производственным заданием.'
    //     },
    //     {
    //         id: 24,
    //         coordinates: [],
    //         img: '/app/assets/hero/tomke.png',
    //         title: 'Томке Владимир Александрович\n',
    //         subTitle: 'Инженер-капитан тяги, старший ревизор по спецзапасам МПС.',
    //         type: 'hero',
    //         text: 'Первый машинист на сети дорог, награжденный орденом Ленина.'
    //     },
    //     {
    //         id: 25,
    //         coordinates: [],
    //         img: '/app/assets/hero/galochkin.png',
    //         title: 'Галочкин Виктор Дмитриевич\n',
    //         subTitle: 'Техник тяги I ранга, старший машинист депо Сонково.',
    //         type: 'hero',
    //         text: 'Много ВСП и эшелонов спас он от бомб вражеской авиации.'
    //     },
    //     {
    //         id: 26,
    //         coordinates: [],
    //         img: '/app/assets/hero/fedorow.png',
    //         title: 'Федоров Владимир Терентьевич\n',
    //         subTitle: 'Старший машинист паровоза СУ-200-60 депо Рыбинск. Техник тяги I ранга. ',
    //         type: 'hero',
    //         text: 'Не раз выходил победителем в единоборстве с вражеской авиацией.'
    //     },
    // ];
}
